import { Link } from 'react-router-dom';
import { categories, aboutInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold mb-4">小野坂唯香</h3>
            <p className="text-sm text-secondary-300 leading-relaxed">
              华语地区最全面的小野坂唯香中文资讯平台，致力于为粉丝提供及时、准确的资讯内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-background-50">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-background-50">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于本站</Link>
              <Link to="/category/news" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">最新动态</Link>
              <Link to="/category/works" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">代表作品</Link>
              <Link to="/category/fanclub" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">粉丝应援</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-background-50">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-secondary-300">
              <span><i className="ri-mail-line mr-1.5"></i>{aboutInfo.contact.email}</span>
              <span><i className="ri-weibo-line mr-1.5"></i>{aboutInfo.contact.weibo}</span>
              <span><i className="ri-bilibili-line mr-1.5"></i>{aboutInfo.contact.bilibili}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 小野坂唯香中文粉丝资讯站. 本站为粉丝自发运营的非官方资讯平台。
          </p>
          <p className="text-xs text-secondary-400">
            Made with <i className="ri-heart-line text-primary-500"></i> by Fans
          </p>
        </div>
      </div>
    </footer>
  );
}